import locale from "localization";
import styles from "./shift-records-details-cash-and-non-cash.module.scss";
import { Text, TextField, Title } from "components/commons";
import { cashOnHandColumn } from "./shift-records-details-cash-non-cash-column";
import { formatAmount, formatAmountV2 } from "utils";
import Big from "big.js";
import { FormMode } from "enums";
import { lpgSafeDropAnchorId, safeDropAnchorId } from "../shift-records-details-completion";

const isNumericString = (val) => {
  return typeof val === "string" && /^-?\d+(\.\d+)?$/.test(val);
};

const trimLeadingZeros = (val) => {
  if (typeof val !== "string") return val;
  if (val === "-" || val === "") return val;
  const trimmed = val.replace(/^(-?)0+(?!$)/, "$1");
  return trimmed === "-0" ? "0" : trimmed;
};

const toCount = (val) => (val === "" || isNaN(Number(val)) ? 0 : Number(val));

const ShiftDetailsCashOnHand = ({ safeDrop, setSafeDrop, pageMode }) => {
  const isEditMode = pageMode === FormMode.Edit;

  const updateRow = (index, field, errorField, rawValue) => {
    const newSafeDrop = [...safeDrop];
    const row = { ...newSafeDrop[index], [field]: rawValue, [errorField]: rawValue === "-" };
    const newTotal = Number(
      Big(row.safeDropItem).add(toCount(row.safeDrop)).add(toCount(row.lpgEndShift)),
    );
    newSafeDrop[index] = {
      ...row,
      total: newTotal,
      totalAmount: Number(Big(row.denomination).mul(newTotal)),
    };
    setSafeDrop(newSafeDrop);
  };

  const renderCountInput = (index, field, errorField, item) =>
    isEditMode ? (
      <>
        <TextField
          error={item[errorField]}
          value={item[field]}
          onChange={(_, { value }) => {
            if (isNumericString(value) || value === "" || value === "-") {
              updateRow(index, field, errorField, value === "" ? "" : trimLeadingZeros(value));
            }
          }}
          onBlur={(_, { value }) => {
            updateRow(index, field, errorField, value === "" ? 0 : trimLeadingZeros(value));
          }}
        />
        {item[errorField] && (
          <Text className={styles.fieldError}>{locale.pleaseEnterAValidAmount}</Text>
        )}
      </>
    ) : (
      <Text className={styles.content}>{item[field]}</Text>
    );

  return (
    <>
      <Title small black>
        {locale.cashOnHand}
      </Title>
      <div className={styles.spacer10} />
      <div className={styles.tableContainer}>
        {safeDrop && safeDrop.length > 0 && (
          <div style={{ padding: "20px" }}>
            <table className={styles.table} style={{ tableLayout: "fixed", width: "100%" }}>
              <thead>
                <tr>
                  {cashOnHandColumn.map((item, i) => {
                    return <th key={i}>{item.text}</th>;
                  })}
                </tr>
              </thead>
              <tbody>
                {safeDrop.map((item, i) => {
                  let denomination = formatAmount(item.denomination);
                  if (item.key === "twenty") {
                    denomination = `${formatAmount(item.denomination)} bills`;
                  } else if (item.key === "twentyCoins") {
                    denomination = `${formatAmount(item.denomination)} coins`;
                  } else if (item.key === "coinAmount") {
                    denomination = locale.coins;
                  }
                  return (
                    <tr key={i}>
                      <td>{denomination}</td>
                      <td>
                        <Text className={styles.content}>{item.fuelAndLubesSafeDrop}</Text>
                      </td>
                      <td>
                        <Text className={styles.content}>{item.lpgSafeDrop}</Text>
                      </td>
                      <td>
                        <Text className={styles.content}>{item.safeDropItem}</Text>
                      </td>
                      <td id={safeDropAnchorId(item.key)} data-incomplete={Boolean(item.error)}>
                        {renderCountInput(i, "safeDrop", "error", item)}
                      </td>
                      <td
                        id={lpgSafeDropAnchorId(item.key)}
                        data-incomplete={Boolean(item.lpgError)}
                      >
                        {renderCountInput(i, "lpgEndShift", "lpgError", item)}
                      </td>
                      <td>
                        <Text className={styles.content}>{Number(Big(item.total))}</Text>
                      </td>
                      <td>
                        <Text className={styles.content}>
                          {formatAmountV2(item.totalAmount, item.totalAmount < 0)}
                        </Text>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
      <div className={styles.spacer50} />
    </>
  );
};

export default ShiftDetailsCashOnHand;
